import { useMemo } from 'react';

import { useGetMultichainCollectionMetadata, useGetTokenMetadata } from '@pkg/hooks/daas';

import { SupportedTokens } from '@app/client';
import { getMashedUrl } from '@app/helpers';
import { useFetchWishlistItems } from '@app/store/zustand';

export const useWishlistThumbnails = (slug?: string) => {
    const { collectionItems: collectionItemsRes, tokenItems } = useFetchWishlistItems({ providedSlug: slug });
    const slugQuery = collectionItemsRes?.map(
        (item) => `${SupportedTokens[item?.network]}.${item?.item?.Collection?.slug}`,
    );
    const { data: collectionData } = useGetMultichainCollectionMetadata({
        slugQuery,
    });
    const collectionItemThumbnails = useMemo(
        () =>
            collectionData
                ? Object.values(collectionData)?.flatMap((items) =>
                      items?.slice(0, 3).map(({ metadata }) => {
                          return metadata?.image_url || metadata?.image || metadata?.banner_image_url;
                      }),
                  )
                : [],
        [collectionData],
    );
    const tokenIds =
        tokenItems
            ?.map((t) => `${t?.network?.toLowerCase()}.${t?.item?.Token?.contract}.${t?.item?.Token?.token_id}`)
            .filter((id) => !!id?.length) || [];

    const { data: tokenMetadata } = useGetTokenMetadata({
        unifiedTokenIds: tokenIds.slice(0, 20),
        disabled: collectionItemThumbnails?.length >= 3 || !tokenIds || !tokenItems?.length,
    });

    return useMemo(() => {
        const thumbnailAssets: string[] = [];
        collectionItemThumbnails.forEach((item) => {
            if (item) {
                thumbnailAssets.push(item);
            }
        });

        tokenMetadata?.forEach((item) => {
            if (item?.image_url) {
                thumbnailAssets.push(item.image_url);
            }
        });

        return thumbnailAssets.map((thumbnail) => getMashedUrl({ url: thumbnail, width: 500 }));
    }, [collectionItemThumbnails, tokenMetadata]);
};
